
















import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Durasi extends Vue {
  @Prop() setDurasi: string;
  @Prop() setLabel!: string;
  label = "";
  placeholder = this.setLabel;
  validasi = [(v) => this.cek()];
  // durasi = null;

  // @Watch("durasi")
  // changeDurasi(val) {
  //   this.$emit("durasi", val);
  // }

  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (this.setDurasi == "" || this.setDurasi == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }
  @Watch("setDurasi")
  valDurasi(val) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (val == "" || val == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("durasi", val);
    this.setDurasi = val;
  }
  cek() {
    if (this.setDurasi) {
      if (isNaN(Number(this.setDurasi)))
        this.setDurasi = this.setDurasi.substring(0, this.setDurasi.length - 1);
    }
    return true;
  }
}
